module.exports = __webpack_public_path__ + "static/media/files-landscapes.44624c93.svg";